import { useEffect } from "react";
import { useCacheStore } from "./cacheStore";
import { useShallow } from "zustand/react/shallow";

export function useInitializeCache() {
    const { status, fetchData } = useCacheStore();

    useEffect(() => {
        if (status === "idle") {
            fetchData();
        }
    }, [status, fetchData]);
}

export function usePhases() {
    return useCacheStore((state) => state.phases);
}

export function useAchievements() {
    return useCacheStore((state) => state.achievements);
}

export function useFinanceTypes() {
    return useCacheStore((state) => state.financeTypes);
}

export function useGameConfiguration() {
    return useCacheStore((state) => state.gameConfiguration);
}

export function useLegal() {
    return useCacheStore((state) => state.legal);
}

export function useMetaTag() {
    return useCacheStore((state) => state.metaTag);
}

export function useCacheStatus() {
    return useCacheStore(
        useShallow((state) => ({
            status: state.status,
            error: state.error,
        })),
    );
}

export function useGameEndData() {
    return useCacheStore((state) => state.gameEnd);
}